module.exports = "<div tabindex=\"-1\" class=\"gw-modal gw-fade {{ windowClass }} gw-modal_animation_{{animationType}}\" ng-class=\"{'in': animate, 'out': !animate, 'fullScreen': fullScreen}\"\r\n     ng-style=\"{'z-index': 1050 + index*10}\">\r\n    <div ng-class=\"{'gw-modal__inner-fullScreen': fullScreen, 'gw-modal__inner-wide': wide, 'gw-modal__inner': !fullScreen && !wide}\" ng-transclude></div>\r\n</div>"


//////////////////
// WEBPACK FOOTER
// ./common/grunt/webpack/loaders/text-loader!./common/js/src/edge/platform/widgets/modal/templates/modal-window-template.html
// module id = 588
// module chunks = 0